import { render, staticRenderFns } from "./OnboardingReactionRoles.vue?vue&type=template&id=4aa2bf02&scoped=true"
import script from "./OnboardingReactionRoles.vue?vue&type=script&lang=js"
export * from "./OnboardingReactionRoles.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OnboardingReactionRoles.vue?vue&type=style&index=1&id=4aa2bf02&prod&scoped=true&lang=css"
import style2 from "./OnboardingReactionRoles.vue?vue&type=style&index=2&id=4aa2bf02&prod&lang=css"
import style3 from "./OnboardingReactionRoles.vue?vue&type=style&index=3&id=4aa2bf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2bf02",
  null
  
)

export default component.exports